// 吃瓜m 首页内容数据（纯静态展示，不接接口）

export const navLinks = [
  { key: "today", label: "今日新瓜", href: "#today" },
  { key: "hot", label: "热瓜有哪些", href: "#hot-rank" },
  { key: "point", label: "最近瓜点", href: "#recent-point" },
  { key: "feed", label: "最新瓜单", href: "#live-feed" },
  { key: "talk", label: "评论区风向", href: "#comment-talk" },
];

// 首屏 · 今日关键词（热梗 chip）
export const hotKeywords = [
  "爆款综艺重录",
  "顶流同框破冰",
  "下饭剧导演道歉",
  "素人逆袭上桌",
  "选秀老瓜被挖",
  "豪门联姻乌龙",
  "片酬缩水疑云",
  "退团单飞实锤",
];

// 今日新瓜 · 精选（上密区开场，标题+短摘要）
export const dailyHots = [
  {
    tag: "刚刚爆",
    title: "某选秀厂牌深夜官宣解散，陪跑六年的站姐在线哭成泪人",
    brief: "厂牌公告只留一句“好聚好散”，评论区却把三年前的天价应援、解散前夜的资源分配全翻了出来。",
    time: "8分钟前",
    reads: "12.4万围观",
    comments: 3861,
  },
  {
    tag: "实锤反转",
    title: "下饭剧导演为“注水结局”公开道歉，声明被扒出与前作同一模板",
    brief: "道歉信还没写完，网友已晒出三段几乎一字不差的“模板式低头”，反转现场比正片还精彩。",
    time: "26分钟前",
    reads: "8.9万围观",
    comments: 2742,
  },
  {
    tag: "同框破冰",
    title: "僵了五年的两大顶流同台颁奖，后台花絮疑似“眼神和解”",
    brief: "同框秒杀热搜，有人磕到原地复活，也有人提醒别急着和好——当年的那场撕扯还没翻篇。",
    time: "41分钟前",
    reads: "15.2万围观",
    comments: 4980,
  },
];

// 热瓜有哪些 · 热瓜榜（榜单体）
export const hotRank = [
  { rank: 1, title: "素人选手靠一句真话杀出重围，导师集体黑脸画面疯传", heat: 98.6 },
  { rank: 2, title: "顶流同框破冰，五年前旧账被一张后台图重新点燃", heat: 97.4 },
  { rank: 3, title: "下饭剧导演公开道歉，网友反手甩出“三版同稿”", heat: 95.8 },
  { rank: 4, title: "豪门联姻乌龙：订婚官宣两小时后，女方工作室火速辟谣", heat: 93.1 },
  { rank: 5, title: "爆款综艺疑似“恶意剪辑”，镜头外观众实拍成新证据", heat: 90.6 },
  { rank: 6, title: "一线花旦片酬缩水被爆，团队回应“本来就是市场价”", heat: 88.2 },
  { rank: 7, title: "退团单飞三年后回踩前队友，老粉：这刀我等了太久", heat: 85.7 },
  { rank: 8, title: "某音乐节压轴换人，主办方只发两个字：不可抗", heat: 82.4 },
];

// 最近瓜点 · 分区（栏目体，标题+短摘要）
export const recentZones = [
  {
    name: "综艺现场",
    icon: "ri-tv-2-line",
    items: [
      { title: "《今日份快乐》第4期录完就吵上热搜，导师团各执一词", brief: "连麦环节现场失控，节目组连夜剪了两版预告试水。" },
      { title: "观察室新嘉宾一句话封神：我就是来吃瓜的", brief: "自嘲式金句刷屏，片方顺势把观察位升级成了主咖位。" },
      { title: "选手淘汰夜被质疑剧本，镜头外观众直播实拍打脸", brief: "剪辑前后对不上，节目组只说“后期存在技术误差”。" },
      { title: "国民综艺回归海报被扒“拼接前任”，美学争议炸开锅", brief: "二创区连夜产出对照图，官微悄悄重传了一张替换版。" },
    ],
  },
  {
    name: "职场饭桌",
    icon: "ri-briefcase-4-line",
    items: [
      { title: "大厂“狼性文化”卷土重来，员工晒出凌晨打卡截图", brief: "部门群公告流出，HR 回应“倡导高效并非强制”。" },
      { title: "00后新人当众拒绝无效加班，老板群里点名表扬", brief: "反转爽文体刷屏，评论区却吵成价值观辩论现场。" },
      { title: "明星经纪人圈集体加急充电，只因新规要求持证上岗", brief: "从业者自嘲：当不了顶流，先当个合格打工人。" },
      { title: "某MCN被曝“黑红KPI”，员工痛诉流量没人味", brief: "一条长文引爆共鸣，同行纷纷转发求行业自律。" },
    ],
  },
  {
    name: "吃瓜避雷",
    icon: "ri-alert-line",
    items: [
      { title: "别急着站队！这条瓜的“证据图”疑似AI批量产出", brief: "放大十倍看手指关节，AI 味扑面而来，理性吃瓜保智商。" },
      { title: "“内部消息截图”一天三张，懂的都懂是造瓜一条龙", brief: "吃瓜第一课：先问来源，再谈立场，最后才信瓜熟。" },
      { title: "上周传遍全网的“惊天大瓜”，已被证实是空穴来风", brief: "辟谣公告落槌，评论区默默删帖，热度一日蒸发九成。" },
      { title: "吃瓜m 提醒：热度越高越要慢半拍，让子弹先飞一会儿", brief: "最新瓜单实时滚动，但真伪请以多方信源交叉为准。" },
    ],
  },
  {
    name: "品牌动向",
    icon: "ri-price-tag-3-line",
    items: [
      { title: "顶流代言到期不续，品牌换人后销量反而翻倍", brief: "粉丝拒买变成竞品免费广告，营销号连夜写复盘。" },
      { title: "茶饮联名上架10分钟售罄，黄牛价炒到5倍", brief: "一杯难求刷屏下午茶，官方回应“正在补货”。" },
      { title: "国货彩妆蹭热梗玩梗翻车，网友：真诚才是必杀技", brief: "撤回重发后口碑回升，玩梗有风险，吃瓜需谨慎。" },
      { title: "老牌零食被扒“情怀营销”，财报一出评论区两边倒", brief: "老粉舍不得骂，路人不买账，品牌群成吵架一线。" },
    ],
  },
];

// 最新瓜单 · 实时滚动 feed（单行流）
export const liveFeed = [
  { time: "刚刚", tag: "新瓜", title: "选秀厂牌解散声明被扒出“一键替换”，连错别字都懒得改" },
  { time: "3分钟前", tag: "热评", title: "下饭剧导演道歉冲上热榜，评论区高赞：先重拍结局再说" },
  { time: "7分钟前", tag: "新瓜", title: "两大顶流同框花絮放出，五年前旧粉晒出“黑脸对比图”" },
  { time: "12分钟前", tag: "辟谣", title: "豪门联姻乌龙反转：订婚只是宣发期“意外流出的物料”" },
  { time: "18分钟前", tag: "实锤", title: "爆款综艺恶意剪辑实锤？导演直播回应当天录制真实经过" },
  { time: "24分钟前", tag: "热评", title: "素人选手靠真话出圈，导师团集体“黑脸”成表情包素材" },
  { time: "31分钟前", tag: "新瓜", title: "音乐节压轴换人官宣，主办方两字回应引发全网二创" },
  { time: "39分钟前", tag: "辟谣", title: "一线花旦片酬缩水系误读，工作室：报价随市场波动" },
  { time: "46分钟前", tag: "热评", title: "退团三年回踩前队友，老粉喊话：别把旧账留到下个五年" },
  { time: "52分钟前", tag: "新瓜", title: "观察室嘉宾自嘲“我就是来吃瓜的”，被官方P进主咖位" },
];

// 评论区风向 · 热议现场（互动氛围醒目）
export const commentPicks = [
  { user: "前排吃瓜的柠檬", badge: "今晚第一个到", text: "蹲了一晚上，终于等到厂牌这条瓜，姐妹们瓜子都磕完了。", likes: 3280, hot: true },
  { user: "理性分析菌", badge: "追根究底", text: "下饭剧那版道歉我逐句比对过，三段几乎一样，建议片方请个新文案。", likes: 2419 },
  { user: "磕糖不站队", badge: "和平主义者", text: "同框破冰我先磕为敬，但别急着和好，让子弹再飞一会儿。", likes: 1962, hot: true },
  { user: "职场打工人", badge: "刚下班", text: "狼性文化那瓜我熟，凌晨打卡不是奋斗是内耗，良心企业卷项目不卷时长。", likes: 1735 },
  { user: "避雷老司机", badge: "十年吃瓜人", text: "截图类瓜我统一打问号，AI都出图了，先验货再站队。", likes: 1488 },
  { user: "熬夜蹲更的", badge: "常在瓜田", text: "最新瓜单刷起来太爽了，一条接一条，别停！我要继续蹲下一颗。", likes: 1102 },
];

// 蹲瓜订阅小条
export const subscribeNote = "把「吃瓜m」收进日程，每天早八点提醒你刷今日新瓜。";